export type VehicleSearchFieldName =
  | 'make'
  | 'model'
  | 'yearMin'
  | 'yearMax'
  | 'budgetMax'
  | 'body'
  | 'fuel'
  | 'transmission'
  | 'country';

/** All nine fields (§16), in the order they read best. */
export const allSearchFields = [
  'make',
  'model',
  'yearMin',
  'yearMax',
  'budgetMax',
  'body',
  'fuel',
  'transmission',
  'country',
] as const satisfies readonly VehicleSearchFieldName[];

/** What a visitor almost always searches by; the rest sit behind "More filters". */
export const primarySearchFields = [
  'make',
  'model',
  'budgetMax',
] as const satisfies readonly VehicleSearchFieldName[];

export const secondarySearchFields = [
  'yearMin',
  'yearMax',
  // First of the extra filters: body type is the one a visitor who opened this
  // panel is most likely to have come for, and since 2026-10-18 it is also the
  // only way to ask the catalogue for trucks rather than cars.
  'body',
  'fuel',
  'transmission',
  'country',
] as const satisfies readonly VehicleSearchFieldName[];

/** A row of fields, or one field per row. */
export type FieldLayout = 'row' | 'column';

/** The year pair is half-width, so "from" and "to" stay on one line. */
export const fieldSize = (name: VehicleSearchFieldName, layout: FieldLayout) => {
  const half = name === 'yearMin' || name === 'yearMax';
  if (layout === 'column') return half ? { xs: 6 } : { xs: 12 };
  return half ? { xs: 6, md: 3 } : { xs: 12, sm: 6, md: 3 };
};
